module.exports = __webpack_public_path__ + "static/img/pic_pdf@2x.b0a56a15.png";